//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { czHomePath } from '~/constant/cz';
name: 'CZhead';
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(['user', 'identities']),
    // headPic() {
    //   return decodeURIComponent(this.$absUrl(this.user.imgUrl));
    // },
  },
  methods: {
    goHome() {
      this.$router.push(czHomePath);
    },
  },
};
